
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("44ixv"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("44ixv", function(module, exports) {

let $2f65eaabe1bcef48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2f65eaabe1bcef48$var$load("dIzOY"),
    $2f65eaabe1bcef48$var$load("alXrq"),
    $2f65eaabe1bcef48$var$load("2YffH"),
    $2f65eaabe1bcef48$var$load("iDB1L"),
    $2f65eaabe1bcef48$var$load("1aTst"),
    $2f65eaabe1bcef48$var$load("eEyVs"),
    $2f65eaabe1bcef48$var$load("6mHrv"),
    $2f65eaabe1bcef48$var$load("awWN9"),
    $2f65eaabe1bcef48$var$load("9CYct"),
    $2f65eaabe1bcef48$var$load("iIoyG"),
    $2f65eaabe1bcef48$var$load("2xn4F"),
    $2f65eaabe1bcef48$var$load("hZtKG"),
    $2f65eaabe1bcef48$var$load("iNmaF"),
    $2f65eaabe1bcef48$var$load("lVO3w"),
    $2f65eaabe1bcef48$var$load("hyzoX"),
    $2f65eaabe1bcef48$var$load("h9Ed7"),
    $2f65eaabe1bcef48$var$load("eBRUf"),
    $2f65eaabe1bcef48$var$load("bogQM"),
    $2f65eaabe1bcef48$var$load("jq3Ai"),
    $2f65eaabe1bcef48$var$load("bv7z8"),
    $2f65eaabe1bcef48$var$load("8A3nE"),
    $2f65eaabe1bcef48$var$load("8YSo7"),
    $2f65eaabe1bcef48$var$load("g7ggm"),
    $2f65eaabe1bcef48$var$load("9S9Mz"),
    $2f65eaabe1bcef48$var$load("kiGNy"),
    $2f65eaabe1bcef48$var$load("7do1E"),
    $2f65eaabe1bcef48$var$load("77dkW"),
    $2f65eaabe1bcef48$var$load("arCL2"),
    $2f65eaabe1bcef48$var$load("g9CVe"),
    $2f65eaabe1bcef48$var$load("6iz6l"),
    $2f65eaabe1bcef48$var$load("4SCW2"),
    $2f65eaabe1bcef48$var$load("855o0"),
    $2f65eaabe1bcef48$var$load("8MfZE"),
    $2f65eaabe1bcef48$var$load("hv4mn"),
    $2f65eaabe1bcef48$var$load("dek7I"),
    $2f65eaabe1bcef48$var$load("3SmkN"),
    $2f65eaabe1bcef48$var$load("dYtBN"),
    $2f65eaabe1bcef48$var$load("kNV5Y"),
    $2f65eaabe1bcef48$var$load("6wr18"),
    $2f65eaabe1bcef48$var$load("kjZZD"),
    $2f65eaabe1bcef48$var$load("bkc7o"),
    $2f65eaabe1bcef48$var$load("2wlUS"),
    $2f65eaabe1bcef48$var$load("9u7sS"),
    $2f65eaabe1bcef48$var$load("1fem1"),
    $2f65eaabe1bcef48$var$load("Wowvf"),
    $2f65eaabe1bcef48$var$load("ffEVr"),
    $2f65eaabe1bcef48$var$load("hhss7"),
    $2f65eaabe1bcef48$var$load("dTsOE"),
    $2f65eaabe1bcef48$var$load("9fvYm"),
    $2f65eaabe1bcef48$var$load("im1Yv"),
    $2f65eaabe1bcef48$var$load("henq4"),
    $2f65eaabe1bcef48$var$load("eylda"),
    $2f65eaabe1bcef48$var$load("8TDGF"),
    $2f65eaabe1bcef48$var$load("8fMw3"),
    $2f65eaabe1bcef48$var$load("hogcU"),
    $2f65eaabe1bcef48$var$load("dAdaw"),
    $2f65eaabe1bcef48$var$load("h3ABO"),
    $2f65eaabe1bcef48$var$load("kC80R"),
    $2f65eaabe1bcef48$var$load("7EorR"),
    $2f65eaabe1bcef48$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.0f13dd48.js.map
